
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <SEO
        title="ALFUNOON Group | مجموعة الفنون للصناعات الحديثة"
        description="مجموعة الفنون للصناعات الحديثة - رواد تصنيع الألمنيوم، الحديد، الزجاج، الرخام، الستانلس ستيل والأخشاب في الخبر، المملكة العربية السعودية."
        canonicalPath="/"
      />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
